// extracted by mini-css-extract-plugin
export default {"container":"Location_container__MO0xr","message":"Location_message__N4v2w","btn":"Location_btn__R3dzA","close":"Location_close__7BHFl"};